import React from 'react'
import Servicios from '../About/Servicios';
import { Container } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import { TypeAnimation } from 'react-type-animation';
import Principal from '../About/Principal';

const Acercas = () => {
  return (
    <>
    <div className='separador'>
        <h3 className='colorini titulo-servicio'><TypeAnimation
        sequence={[
            "Acerca de nosotros.",500,
          ]} 
          repeat={0}
        
        style={{ fontSize: '1.5em' }}/></h3></div>
<Container fluid>
<Principal/>
</Container>
<div className='separador-f'>
        <Footer/>
        </div>        
  </>
  
  )
}
  

export default Acercas